import { render, staticRenderFns } from "./SettingsServicesCreate.vue?vue&type=template&id=db8e4cbc&scoped=true&"
import script from "./SettingsServicesCreate.vue?vue&type=script&lang=js&"
export * from "./SettingsServicesCreate.vue?vue&type=script&lang=js&"
import style0 from "./SettingsServicesCreate.vue?vue&type=style&index=0&id=db8e4cbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8e4cbc",
  null
  
)

export default component.exports